module.exports = require("merge-refs");